import { render, staticRenderFns } from "./CompetitionSummaryView.vue?vue&type=template&id=a76675b0"
import script from "./CompetitionSummaryView.vue?vue&type=script&lang=js"
export * from "./CompetitionSummaryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports